export function loadStoredConfig(storageKey, defaults) {
  const fallback = {
    ...defaults,
    visibleFields: { ...defaults.visibleFields },
  };
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw);
    return {
      ...fallback,
      ...parsed,
      visibleFields: {
        ...fallback.visibleFields,
        ...(parsed.visibleFields || {}),
      },
    };
  } catch (e) {
    /* invalid JSON or storage unavailable — keep defaults */
    return fallback;
  }
}

export function saveStoredConfig(storageKey, value) {
  try {
    localStorage.setItem(storageKey, JSON.stringify(value));
  } catch (e) {
    /* quota or disabled — ignore */
  }
}
